export default __webpack_public_path__ + "static/media/mathias_xl.a4d3e93b.jpg";